import { combineReducers } from 'redux';

import enrollmentOn from './enrollmentOn';
import newInviteStatus from './newInviteStatus';
import rentPrice from './rentPrice';
import inviteInfoFromLeadInquiry from './inviteInfoFromLeadInquiry';

export default combineReducers({
  enrollmentOn,
  newInviteStatus,
  rentPrice,
  inviteInfoFromLeadInquiry,
});
